module.exports = __webpack_public_path__ + "img/interview_dont.c69917e3.jpg";